import React from "react";
import { FiBell } from "react-icons/fi";

function MobileChatHeader() {
  return (
    <div className="mobile-chat-header d-flex d-lg-none align-items-center justify-content-between px-3 py-2 shadow-sm">

      {/* LEFT - Avatar + All Chats */}
      <div className="d-flex align-items-center">
        <img
          src="http://192.168.10.227:5000/uploads/profile_images/2025/11/1764085615483-950345453.webp"
          alt="avatar"
          className="chat-avatar"
        />
        <span className="chat-title ms-2">All Chats 11</span>
      </div>

      {/* RIGHT - Notification Bell */}
      <FiBell className="chat-bell-icon" size={22} />
    </div>
  );
}

export default MobileChatHeader;
